import { Avatar, Box, styled } from '@mui/material';
import { useContext, useState } from 'react';
import DefaultProfileIcon from 'src/assets/icons/DefaultAvatar.png';
import { LoggedInUserContext } from 'src/contexts/LoggedInUsersContext';
import { LoginType } from 'src/enums';
import { filePaths } from 'src/utils/properties';

const ProfileAvatar = () => {
  const { contextLoggedInUser } = useContext(LoggedInUserContext);
  return (
    <Avatar
      src={
        contextLoggedInUser?.profile === null ||
        contextLoggedInUser?.profile === undefined
          ? DefaultProfileIcon
          : (contextLoggedInUser?.userType === LoginType.PARENT
              ? filePaths.PARENT
              : filePaths.STUDENT) + contextLoggedInUser?.profile
      }
      variant="circular"
      sx={{
        border: '1px solid #FA7B17',
        background: '#FFE2BB'
      }}
    />
  );
};

const PopeOverProfileAvatar = (props) => {
  const { contextLoggedInUser } = useContext(LoggedInUserContext);
  return (
    <Avatar
      src={
        contextLoggedInUser?.profile === null ||
        contextLoggedInUser?.profile === undefined
          ? DefaultProfileIcon
          : (contextLoggedInUser?.userType === LoginType.PARENT
              ? filePaths.PARENT
              : filePaths.STUDENT) + contextLoggedInUser?.profile
      }
      variant="circular"
      sx={{
        border: '1px solid #FA7B17',
        maxWidth: '75px',
        minWidth: '50px',
        width: '75px',
        height: '75px',
        strokeWidth: '2px',
        stroke: '#FFF',
        backgroundColor: '#FFE2BB'
      }}
    />
  );
};

const PopoverParentProfileMyKidsAvatar = (props) => {
  const [imgSrc, setImgSrc] = useState(
    props.src === null || props.src === undefined
      ? DefaultProfileIcon
      : filePaths.STUDENT + props.src
  );
  const handleError = () => {
    setImgSrc(DefaultProfileIcon);
  };
  return (
    <Avatar
      src={imgSrc}
      onError={handleError}
      variant="circular"
      sx={{
        border: '1px solid #FA7B17',
        background: '#FFE2BB'
      }}
    />
  );
};

const PopoverStudentProfileParentAvatar = (props) => {
  const [imgSrc, setImgSrc] = useState(
    props.src === null || props.src === undefined
      ? DefaultProfileIcon
      : filePaths.PARENT + props.src
  );
  const handleError = () => {
    setImgSrc(DefaultProfileIcon);
  };
  return (
    <Avatar
      src={imgSrc}
      onError={handleError}
      variant="circular"
      sx={{
        border: '1px solid #FA7B17',
        background: '#FFE2BB'
      }}
    />
  );
};

export const HeaderLoaderBox = styled(Box)(({ theme }) => ({
  margin: '10px 20px'
}));

export {
  ProfileAvatar,
  PopeOverProfileAvatar,
  PopoverParentProfileMyKidsAvatar,
  PopoverStudentProfileParentAvatar
};
